import classes from "./NoticeBoardLarge.module.css";

const NoticeBoardLarge = () => {
  const bookString =
    process.env.REACT_APP_ASSETS_URL + "/assets/icons/book_icon_thick.svg";
  const menuString =
    process.env.REACT_APP_ASSETS_URL + "/assets/icons/menu_icon.svg";

  return (
    <div className={classes.noticeBoard}>
      <div className={classes.title}>Important!</div>
      <div className={classes.notice_body}>
        <div className={classes.notice_list}>
          <div className={classes.notice_item}>
            • Navigate using the menu
            <img src={menuString} alt="new" className={classes.cart_image} width="70" height="70"/>
          </div>
          <div className={classes.notice_item}>
          • Add cocktails to your cart
             <img src={bookString} alt="new" className={classes.cart_image} width="70" height="70"/>
          </div>
          <div className={classes.notice_item}>• Create a cocktail book using your cart cocktails</div>
          <div className={classes.notice_item}>• Find your new book in your bookshelf</div>
          <div className={classes.notice_item}>• Read the Help page for further information</div>
        </div>
      </div>
    </div>
  );
};

export default NoticeBoardLarge;
